import { ImgProps } from '../components/ProductWorkbenchCanvas/types';

function handleCenterLayer(draggable: ImgProps[]) {
    let newLayers = {};
    draggable.map((layer) => {
        // @ts-ignore
        layer.x = undefined;
        layer.y = undefined;
        // @ts-ignore
        newLayers[layer.id] = layer;
    });
    return newLayers;
}

export default handleCenterLayer;
